import { Element as SlateElement, type Descendant } from 'slate';

import type { RichTextNode } from 'types';

import type { CustomText, MarkFormat } from '../../types/RichTextEditor';

export const HOTKEYS: Record<string, MarkFormat> = {
  'mod+b': 'bold',
  'mod+i': 'italic',
};

export const createEmptyValue = (): Descendant[] => [{ type: 'paragraph', children: [{ text: '' }] }];

export const normalizeValue = (value?: RichTextNode[]): Descendant[] => {
  if (!value || value.length === 0) return createEmptyValue();
  return value as Descendant[];
};

export const isEditorEmpty = (value: Descendant[]): boolean => {
  if (value.length === 0) return true;
  return (
    value.length === 1 &&
    SlateElement.isElement(value[0]) &&
    value[0].type === 'paragraph' &&
    value[0].children.length === 1 &&
    (value[0].children[0] as CustomText).text === ''
  );
};
